/**
 * Runtime configuration.
 *
 * API_BASE_URL is injected at build time by webpack's DefinePlugin, which picks
 * the host per mode: `http://localhost:8000` for `npm run dev`,
 * `https://app.sprintspeak.pl` for `npm run build`. Set the `API_BASE_URL` env
 * var to override either; an empty value means same origin (relative
 * `/api/...`), which in development is transparently proxied to the backend
 * (see `devServer.proxy` in webpack.config.js).
 */
export const API_BASE_URL = process.env.API_BASE_URL;

/**
 * The app's version, injected from `package.json` at build time — the single
 * source of truth for what "Wersja" shows on the "O aplikacji" screen. Not to be
 * confused with the *content* version echoed to `/study/main`, which the server
 * owns and `STORAGE_KEYS.appVersion` caches.
 */
export const APP_VERSION = process.env.APP_VERSION;

export const STORAGE_KEYS = {
  /** Long-lived access token (localStorage). */
  accessToken: 'sprintspeak.auth.jwt',
  /** Signed-in user's e-mail, returned by /verify alongside the JWT (localStorage). */
  userEmail: 'sprintspeak.auth.email',
  /** Short-lived registration token + email during the sign-in flow (sessionStorage). */
  pendingRegistration: 'sprintspeak.auth.pending',
  /** Latest app/content version reported by /study/main; echoed back on the next request (localStorage). */
  appVersion: 'sprintspeak.app.version',
  /**
   * The required-update notice from /study/main, kept so the gate also holds with
   * no network (localStorage). Tagged with the `APP_VERSION` it blocked — see
   * `showHardUpdateGate` in `views/home.js`.
   */
  hardUpdate: 'sprintspeak.app.hardUpdate',
};
